import {CSSProperties, useRef} from 'react';
import AspectRatioBox from '../component/AspectRatioBox';
import PageIframe from '../component/PageIframe';
import useIntersection from '../hook/useIntersection';
import useUserAgent from '../hook/useUserAgent';
import {IExternalVideoType, IVideoClip} from '../type';

interface IProps {
  className?: string;
  wrapperClassName?: string;
  style?: CSSProperties;
  video: IVideoClip;
  isLazy?: boolean;
  isStreaming?: boolean;
  onIntersection?: (isIntersecting: boolean) => void;
}

export default function VideoClip({
  className,
  wrapperClassName,
  style,
  video,
  isLazy = true,
  isStreaming,
  onIntersection,
}: IProps) {
  const {type, key} = video;
  const videoRef = useRef<HTMLDivElement>(null);

  useIntersection({targetRef: videoRef, onIntersection});

  const userAgent = useUserAgent();
  return (
    <AspectRatioBox
      ref={videoRef}
      className={className}
      wrapperClassName={wrapperClassName}
      style={style}
      aspectRatio={VIDEO_RATIO}
    >
      <PageIframe
        isLazy={isLazy}
        src={getVideoEmbedUrl(type, {
          key,
          isMobile: !!userAgent?.isMobile,
          isStreaming,
        })}
        allowFullScreen
        allow="encrypted-media"
      />
    </AspectRatioBox>
  );
}

const VIDEO_RATIO = 188 / 335;

function getVideoEmbedUrl(
  type: IExternalVideoType,
  {
    key,
    isMobile,
    isStreaming,
  }: {key: string; isMobile?: boolean; isStreaming?: boolean}
) {
  switch (type) {
    case 'kakaoTv':
      return isStreaming
        ? `https://tv.kakao.com/embed/player/livelink/${key}`
        : `https://tv.kakao.com/embed/player/cliplink/${key}`;
    case 'youtube':
      return `https://www.youtube.com/embed/${key}`;
    case 'afreecaTv':
      return isMobile
        ? `https://m.afreecatv.com/#/player/${key}/direct`
        : `https://play.afreecatv.com/${key}/direct`;
  }
}
